import type { CountryCode } from "utils/mandators/enums";

export type FeatureFlagValue = {
  enabled: boolean;
  disabledTenants: CountryCode[];
  parent?: FeatureFlagKey;
};

export enum FeatureFlagKey {
  WIZARDS = "WIZARDS",
  FIRE_PROTECTION_WIZARD = "FIRE_PROTECTION_WIZARD",
  ROOM_CONTROL_WIRED_WIZARD = "ROOM_CONTROL_WIRED_WIZARD",
  ROOM_CONTROL_WIRELESS_WIZARD = "ROOM_CONTROL_WIRELESS_WIZARD",
  X_CUBE_WIZARD = "X_CUBE_WIZARD",
  X_FANS_WIZARD = "X_FANS_WIZARD",
  PRODUCTS = "PRODUCTS",
  PROJECTS = "PROJECTS",
  LIBRARY = "LIBRARY",
  RESULTING_LIST = "RESULTING_LIST",
}

export type FeatureFlags = Record<FeatureFlagKey, FeatureFlagValue>;
export type PartialFeatureFlags = Partial<
  Record<FeatureFlagKey, Partial<FeatureFlagValue>>
>;
